<section>
  <div class="container">
    <div class="title">
      <h1>
        {{ cat_name }}
      </h1>
    </div>

    <div class="main">
      <div class="loader-container" *ngIf="isLoading">
        <div class="loader"></div>
      </div>

      <div class="prod-grid">
        <div
          class="prod-cell"
          *ngFor="
            let item of products
              | paginate
                : {
                    itemsPerPage: 20,
                    currentPage: page,
                    totalItems: totalCount
                  }
          "
        >
          <div class="product-item" (click)="productDetails(item)">
            <figure class="product-thumb">
              <img [src]="item.images[0].image_url" [alt]="item.name" />
              <div class="action-links">
                <button
                  class="btn btn-view"
                  [routerLink]="['/products_details', item.id]"
                >
                  {{ 'shop.view' | translate }}
                </button>
              </div>
            </figure>
          </div>
          <div class="product-content">
            <h5 class="product-name text-truncate">
              <a class="">{{ item.name }}</a>
            </h5>
            <div class="ratings">
              <a *ngFor="let rate of item.rating_arr"
                ><i class="ti-star"></i
              ></a>
            </div>
            <div *ngIf="item.rating_arr.length == 0" class="ratings">
              <a><i class="ti-star"></i></a>
              <a><i class="ti-star"></i></a>
              <a><i class="ti-star"></i></a>
              <a><i class="ti-star"></i></a>
              <a><i class="ti-star"></i></a>
            </div>
            <span class="price-was" *ngIf="item.discount > 0">LE.{{ item.price }}</span>
            <p class="price">LE.{{ effectivePrice(item) }}</p>
          </div>
        </div>
      </div>

      <div class="pagination">
        <pagination-controls
          (pageChange)="pageChanged($event)"
          (pageChange)="page = $event"
        ></pagination-controls>
      </div>
    </div>
  </div>
</section>
